export const LANGUAGE_OPTIONS = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "hi", label: "Hindi", nativeLabel: "हिन्दी" },
  { code: "or", label: "Odia", nativeLabel: "ଓଡ଼ିଆ" },
];

export const TRANSLATIONS = {
  en: {
    "language.switcher.title": "Language",
    "navigation.itineraryPlanner": "Itinerary Planner",
    "navigation.forms": "Forms",
    "footer.forms": "Forms",
  },
  hi: {
    "language.switcher.title": "भाषा",
    "navigation.home": "मुखपृष्ठ",
    "navigation.destinations": "गंतव्य स्थल",
    "navigation.nightStayBooking": "रात्रि प्रवास बुकिंग",
    "navigation.nightStay": "रात्रि प्रवास",
    "navigation.destinationDetails": "गंतव्य विवरण",
    "navigation.myBookings": "मेरी बुकिंग्स",
    "navigation.supportDesk": "सहायता डेस्क",
    "navigation.contact": "संपर्क",
    "navigation.contactUs": "हमसे संपर्क करें",
    "navigation.jungleSafari": "जंगल सफारी",
    "navigation.cruise": "क्रूज़ (नौकायन)",
    "navigation.booking": "बुकिंग",
    "navigation.entryTicket": "प्रवेश टिकट",
    "navigation.service": "सेवाएँ",
    "navigation.serviceDetails": "सेवा विवरण",
    "navigation.activities": "गतिविधियाँ",
    "navigation.activitiesDetails": "गतिविधि विवरण",
    "navigation.pages": "पृष्ठ",
    "navigation.blog": "ब्लॉग",
    "navigation.blogDetails": "ब्लॉग विवरण",
    "navigation.about": "हमारे बारे में",
    "navigation.shop": "दुकान",
    "navigation.shopDetails": "दुकान विवरण",
    "navigation.cartPage": "कार्ट पेज",
    "navigation.checkout": "चेकआउट",
    "navigation.wishlist": "इच्छा सूची",
    "navigation.gallery": "गैलरी",
    "navigation.ourTour": "हमारे टूर",
    "navigation.tourDetails": "टूर विवरण",
    "navigation.resort": "रिसॉर्ट पेज",
    "navigation.resortDetails": "रिसॉर्ट विवरण",
    "navigation.tourGuide": "टूर गाइड",
    "navigation.tourGuideDetails": "टूर गाइड विवरण",
    "navigation.agentRegistration": "एजेंट पंजीकरण",
    "navigation.agentLogin": "एजेंट लॉगिन",
    "navigation.bookingAgents": "बुकिंग एजेंट",
    "navigation.taxiOperators": "टैक्सी संचालक",
    "navigation.faq": "सामान्य प्रश्न",
    "navigation.price": "मूल्य पृष्ठ",
    "navigation.error": "त्रुटि पृष्ठ",
    "navigation.itineraryPlanner": "यात्रा योजना उपकरण",
    "navigation.forms": "फॉर्म",
    "navigation.planFirstStay": "अपनी पहली यात्रा की योजना बनाएं",
    "navigation.viewAll": "सब देखें",
    "banner.slide1.subtitle": "प्रकृति के छिपे रत्न को खोजें",
    "banner.slide1.title": "भितरकनिका की खोज करें",
    "banner.slide1.primaryCta": "अपनी यात्रा की योजना बनाएं",
    "banner.slide1.secondaryCta": "और जानें",
    "banner.slide2.subtitle": "हमारे साथ अविस्मरणीय आनंद प्राप्त करें",
    "banner.slide2.title": "आइए आपके लिए सर्वश्रेष्ठ यात्रा बनाएं",
    "banner.slide2.primaryCta": "टूर्स देखें",
    "banner.slide2.secondaryCta": "हमारी सेवाएं",
    "banner.slide3.subtitle": "हमारे साथ अविस्मरणीय आनंद प्राप्त करें",
    "banner.slide3.title": "पूरी दुनिया की सुंदरता को खोजें",
    "banner.slide3.primaryCta": "टूर्स देखें",
    "banner.slide3.secondaryCta": "हमारी सेवाएं",
    "category.section.subtitle": "मज़ा और रोमांच खोजें",
    "category.section.title": "गतिविधियाँ",
    "category.link.seeMore": "और देखें",
    "category.item.cycling": "साइक्लिंग",
    "category.item.birding": "पक्षी अवलोकन",
    "category.item.trek": "जंगल ट्रेक",
    "category.item.boating": "नौकायन",
    "category.item.adventure": "रोमांच",
    "category.item.sports": "खेल",
    "category.item.folkDance": "लोक नृत्य",
    "popularDestinations.subtitle": "शीर्ष गंतव्य",
    "popularDestinations.title": "लोकप्रिय गंतव्य",
    "popularDestinations.cta": "सब देखें",
    "about.subtitle": "इको-टूर ओडिशा अपडेट्स",
    "about.title": "प्रकृति का अन्वेषण करें, जिम्मेदारी से यात्रा करें",
    "about.description":
      "ओडिशा प्रसिद्ध जंगलों, घाटियों, जलप्रपातों, ऊंचे शिखरों और हाथी, बाघ, तेंदुए, हॉर्नबिल तथा दुर्लभ प्रवासी पक्षियों सहित अद्भुत वन्यजीवन का घर है। ईको-रिसॉर्ट, ट्रेकिंग ट्रेल, पक्षी-दर्शन टूर और सतत सफ़ारी के साथ, ओडिशा हर प्रकृति प्रेमी के लिए अविस्मरणीय अनुभव प्रदान करता है।",
    "about.feature.exclusiveTrip.title": "विशेष यात्रा",
    "about.feature.exclusiveTrip.text":
      "बहुत सी विविध अनुभवों से भरपूर यात्राएँ आपका इंतज़ार कर रही हैं।",
    "about.feature.professionalGuide.title": "पेशेवर मार्गदर्शक",
    "about.feature.professionalGuide.text":
      "हमारे अनुभवी गाइड सुनिश्चित करते हैं कि यात्रा जानकारीपूर्ण और सुरक्षित रहे।",
    "about.cta": "और जानें",
    "popularTours.subtitle": "आपके लिए सर्वश्रेष्ठ स्थान",
    "popularTours.title": "सबसे लोकप्रिय टूर",
    "popularTours.description":
      "ओडिशा के प्रत्येक नेचर पार्क से चुने गए ठहराव। दर्शाया गया मूल्य प्रति व्यक्ति प्रति रात का है, जिसमें शिविर के अनुसार भोजन शामिल है।",
    "popularTours.ratingLabel": "रेटेड",
    "popularTours.ratingOutOf": "में से 5",
    "popularTours.ratingCount": "रेटिंग्स",
    "popularTours.priceSuffix": "प्रति व्यक्ति",
    "popularTours.durationDay": "दिन",
    "popularTours.durationDays": "दिन",
    "popularTours.bookCta": "अब बुक करें",
    "gallery.subtitle": "चयनित पल",
    "gallery.title": "ओडिशा नेचर कैंप्स – ताजा गैलरी",
    "tourOperators.subtitle": "हमारे टूर ऑपरेटर्स से मिलें",
    "tourOperators.title": "टूर ऑपरेटर्स",
    "whatsNew.subtitle": "इको-टूर ओडिशा",
    "whatsNew.title": "इको-टूर से समाचार और लेख",
    "whatsNew.cta": "और समाचार देखें",
    "whatsNew.readMore": "और पढ़ें",
    "footer.quickLinks": "त्वरित लिंक",
    "footer.agents": "एजेंट",
    "footer.address": "पता",
    "footer.contact.phone": "फ़ोन",
    "footer.contact.email": "ईमेल",
    "footer.about":
      "ओडिशा फॉरेस्ट डेवलपमेंट कॉर्पोरेशन, ओडिशा सरकार का उपक्रम",
    "footer.refund": "रिफंड और रद्दीकरण",
    "footer.privacy": "गोपनीयता नीति",
    "footer.terms": "नियम और शर्तें",
    "footer.feedback": "आगंतुक प्रतिक्रिया",
    "footer.forms": "फॉर्म",
    "footer.department": "पर्यटन विभाग, ओडिशा सरकार",
    "footer.brand": "इको टूर ओडिशा",
    "footer.copyright":
      "कॉपीराइट 2025 इको टूर ओडिशा। सर्वाधिकार सुरक्षित।",
    "footer.copyrightPrefix": "कॉपीराइट 2025",
    "footer.copyrightSuffix": "सर्वाधिकार सुरक्षित।",
    "booking.tabs.accommodation": "आवास",
    "booking.tabs.jungleSafari": "जंगल सफारी",
    "booking.tabs.cruise": "क्रूज़",
    "booking.tabs.entryTicket": "प्रवेश टिकट",
    "booking.tabs.activities": "गतिविधियाँ",
    "sidebar.fallback.jungleSafari": "जंगल सफारी बुकिंग",
    "sidebar.fallback.nightStay": "रात्रि प्रवास बुकिंग",
    "sidebar.meta.bookedOn": "बुक किया गया",
    "sidebar.meta.bookingId": "बुकिंग",
    "sidebar.fallback.supportQuery": "सहायता प्रश्न",
    "sidebar.tab.bookings": "बुकिंग्स",
    "sidebar.tab.queries": "प्रश्न",
    "sidebar.empty.bookings": "आपकी पुष्टि की गई बुकिंग और हाल के प्रयास यहाँ दिखाई देंगे।",
    "sidebar.empty.queries": "आप द्वारा बनाई गई सहायता टिकट यहाँ त्वरित फॉलो-अप के लिए सूचीबद्ध रहेंगी।",
    "sidebar.viewAllBookings": "सभी बुकिंग्स देखें",
    "sidebar.viewAllQueries": "सभी प्रश्न देखें",
    "sidebar.guestHint": "अगली बार बुकिंग करते समय साइन इन करें ताकि आपका प्रोफाइल स्नैपशॉट यहाँ दिखाई दे।",
    "sidebar.navigation": "नेविगेशन",
    "sidebar.reachUs": "हमसे संपर्क करें",
    "sidebar.signOut": "साइन आउट",
  },
  or: {
    "language.switcher.title": "ଭାଷା",
    "navigation.home": "ମୂଳ ପୃଷ୍ଠା",
    "navigation.destinations": "ଗନ୍ତବ୍ୟସ୍ଥଳୀ",
    "navigation.nightStayBooking": "ରାତିରେ ରହିବା ବୁକିଂ",
    "navigation.nightStay": "ରାତିରେ ରହିବା",
    "navigation.destinationDetails": "ଗନ୍ତବ୍ୟ ବିବରଣୀ",
    "navigation.myBookings": "ମୋ ବୁକିଂଗୁଡ଼ିକ",
    "navigation.supportDesk": "ସମର୍ଥନ କେନ୍ଦ୍ର",
    "navigation.contact": "ଯୋଗାଯୋଗ",
    "navigation.contactUs": "ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ",
    "navigation.jungleSafari": "ଜଙ୍ଗଲ ସଫାରି",
    "navigation.cruise": "କ୍ରୁଜ୍ (ନୌକାଭ୍ରମଣ)",
    "navigation.booking": "ବୁକିଂ",
    "navigation.entryTicket": "ପ୍ରବେଶ ଟିକେଟ",
    "navigation.service": "ସେବା",
    "navigation.serviceDetails": "ସେବାର ବିବରଣୀ",
    "navigation.activities": "କାର୍ଯ୍ୟକଳାପ",
    "navigation.activitiesDetails": "କାର୍ଯ୍ୟକଳାପ ବିବରଣୀ",
    "navigation.pages": "ପୃଷ୍ଠା",
    "navigation.blog": "ବ୍ଲଗ୍",
    "navigation.blogDetails": "ବ୍ଲଗ୍ ବିବରଣୀ",
    "navigation.about": "ଆମ ବିଷୟରେ",
    "navigation.shop": "ଦୋକାନ",
    "navigation.shopDetails": "ଦୋକାନ ବିବରଣୀ",
    "navigation.cartPage": "କାର୍ଟ ପୃଷ୍ଠା",
    "navigation.checkout": "ଚେକଅଉଟ୍",
    "navigation.wishlist": "ଇଚ୍ଛାତାଲିକା",
    "navigation.gallery": "ଗ୍ୟାଲେରି",
    "navigation.ourTour": "ଆମର ଭ୍ରମଣ",
    "navigation.tourDetails": "ଭ୍ରମଣ ବିବରଣୀ",
    "navigation.resort": "ରିସର୍ଟ ପୃଷ୍ଠା",
    "navigation.resortDetails": "ରିସର୍ଟ ବିବରଣୀ",
    "navigation.tourGuide": "ଟୁର ଗାଇଡ୍",
    "navigation.tourGuideDetails": "ଟୁର ଗାଇଡ୍ ବିବରଣୀ",
    "navigation.agentRegistration": "ଏଜେଣ୍ଟ ନିବନ୍ଧନ",
    "navigation.agentLogin": "ଏଜେଣ୍ଟ ଲଗଇନ୍",
    "navigation.bookingAgents": "ବୁକିଂ ଏଜେଣ୍ଟମାନେ",
    "navigation.taxiOperators": "ଟ୍ୟାକ୍ସି ଓପେରେଟର୍ମାନେ",
    "navigation.faq": "ପ୍ରାୟ ପଚରା ପ୍ରଶ୍ନ",
    "navigation.price": "ମୂଲ୍ୟ ପୃଷ୍ଠା",
    "navigation.error": "ତ୍ରୁଟି ପୃଷ୍ଠା",
    "navigation.itineraryPlanner": "ଯାତ୍ରା ପରିକଳ୍ପନା",
    "navigation.forms": "ଫର୍ମ",
    "navigation.planFirstStay": "ଆପଣଙ୍କ ପ୍ରଥମ ଯାତ୍ରା ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "navigation.viewAll": "ସବୁ ଦେଖନ୍ତୁ",
    "banner.slide1.subtitle": "ପ୍ରକୃତିର ଲୁଚିତ ରତ୍ନକୁ ଅନ୍ୱେଷଣ କରନ୍ତୁ",
    "banner.slide1.title": "ଭିତରକନିକାକୁ ଅନ୍ୱେଷଣ କରନ୍ତୁ",
    "banner.slide1.primaryCta": "ଆପଣଙ୍କ ଯାତ୍ରା ଯୋଜନା କରନ୍ତୁ",
    "banner.slide1.secondaryCta": "ଅଧିକ ଜାଣନ୍ତୁ",
    "banner.slide2.subtitle": "ଆମ ସହିତ ଅବିସ୍ମରଣୀୟ ଆନନ୍ଦ ପାଆନ୍ତୁ",
    "banner.slide2.title": "ଆସନ୍ତୁ, ଆମେ ସର୍ବୋତ୍ତମ ଯାତ୍ରା ତିଆରି କରିବା",
    "banner.slide2.primaryCta": "ଟୁର୍ସ ଦେଖନ୍ତୁ",
    "banner.slide2.secondaryCta": "ଆମ ସେବାଗୁଡ଼ିକ",
    "banner.slide3.subtitle": "ଆମ ସହିତ ଅବିସ୍ମରଣୀୟ ଆନନ୍ଦ ପାଆନ୍ତୁ",
    "banner.slide3.title": "ସମଗ୍ର ବିଶ୍ୱର ସୌନ୍ଦର୍ଯ୍ୟ ଅନ୍ୱେଷଣ କରନ୍ତୁ",
    "banner.slide3.primaryCta": "ଟୁର୍ସ ଦେଖନ୍ତୁ",
    "banner.slide3.secondaryCta": "ଆମ ସେବାଗୁଡ଼ିକ",
    "category.section.subtitle": "ମଜା ଏବଂ ରୋମାଞ୍ଚ ଅନ୍ୱେଷଣ କରନ୍ତୁ",
    "category.section.title": "କାର୍ଯ୍ୟକଳାପ",
    "category.link.seeMore": "ଅଧିକ ଦେଖନ୍ତୁ",
    "category.item.cycling": "ସାଇକ୍ଲିଂ",
    "category.item.birding": "ପକ୍ଷୀ ଦେଖିବା",
    "category.item.trek": "ଜଙ୍ଗଲ ଟ୍ରେକ୍",
    "category.item.boating": "ନୌକାଭ୍ରମଣ",
    "category.item.adventure": "ରୋମାଞ୍ଚ",
    "category.item.sports": "ଖେଳ",
    "category.item.folkDance": "ଲୋକନୃତ୍ୟ",
    "popularDestinations.subtitle": "ଶୀର୍ଷ ଗନ୍ତବ୍ୟ",
    "popularDestinations.title": "ଲୋକପ୍ରିୟ ଗନ୍ତବ୍ୟ",
    "popularDestinations.cta": "ସବୁ ଦେଖନ୍ତୁ",
    "about.subtitle": "ଇକୋଟୁର ଓଡ଼ିଶା ସମ୍ବାଦ",
    "about.title": "ପ୍ରକୃତିକୁ ଅନ୍ୱେଷଣ କରନ୍ତୁ, ଦାୟିତ୍ୱଶୀଳ ଭାବରେ ଯାତ୍ରା କରନ୍ତୁ",
    "about.description":
      "ଓଡ଼ିଶା ପ୍ରସିଦ୍ଧ ଜଙ୍ଗଲ, ଉପତ୍ୟକା, ଜଳପ୍ରପାତ, ଉଚ୍ଚ ଶିଖର ଏବଂ ହାତୀ, ବାଘ, ଚିତା, ହରିଣା କଳଙ୍ଗା ଓ ଦୁର୍ଲଭ ପ୍ରବାସୀ ପକ୍ଷୀ ସହିତ ଅଦ୍ଭୁତ ପ୍ରାଣୀଜଗତର ଗୃହ। ଇକୋ-ରିସର୍ଟ, ଟ୍ରେକିଂ ପଥ, ପକ୍ଷୀ ଦର୍ଶନ ଟୁର ଓ ସସ୍ଥାୟୀ ସଫାରି ସହିତ, ଓଡ଼ିଶା ପ୍ରକୃତିପ୍ରେମୀଙ୍କ ପାଇଁ ଅବିସ୍ମରଣୀୟ ଅନୁଭୂତି ଦେଇଥାଏ।",
    "about.feature.exclusiveTrip.title": "ବିଶେଷ ଭ୍ରମଣ",
    "about.feature.exclusiveTrip.text":
      "ବିଭିନ୍ନ ପଦ୍ଧତିର ଅନୁଭବ ଆପଣଙ୍କ ପାଇଁ ଅପେକ୍ଷାରତ।",
    "about.feature.professionalGuide.title": "ପ୍ରଶିକ୍ଷିତ ଗାଇଡ୍",
    "about.feature.professionalGuide.text":
      "ଆମ ଅନୁଭବୀ ଗାଇଡ୍ମାନେ ଯାତ୍ରାକୁ ସୂଚନାମୂଳକ ଓ ସୁରକ୍ଷିତ କରନ୍ତି।",
    "about.cta": "ଅଧିକ ଜାଣନ୍ତୁ",
    "popularTours.subtitle": "ଆପଣଙ୍କ ପାଇଁ ଶ୍ରେଷ୍ଠ ସ୍ଥାନ",
    "popularTours.title": "ଅତ୍ୟନ୍ତ ଲୋକପ୍ରିୟ ଟୁର",
    "popularTours.description":
      "ଓଡ଼ିଶାର ପ୍ରତ୍ୟେକ ପ୍ରକୃତି ଉଦ୍ୟାନରୁ ପସନ୍ଦକୃତ ବସବାସ। ଦର୍ଶାଯାଇଥିବା ମୂଲ୍ୟ ପ୍ରତିବ୍ୟକ୍ତି ପ୍ରତି ରାତି ପାଇଁ, ଶିବିର ଅନୁସାରେ ଭୋଜନ ସହିତ।",
    "popularTours.ratingLabel": "ମୂଲ୍ୟାୟନ",
    "popularTours.ratingOutOf": "ରୁ 5",
    "popularTours.ratingCount": "ରେଟିଂ",
    "popularTours.priceSuffix": "ପ୍ରତି ବ୍ୟକ୍ତି",
    "popularTours.durationDay": "ଦିନ",
    "popularTours.durationDays": "ଦିନ",
    "popularTours.bookCta": "ଏବେ ବୁକ୍ କରନ୍ତୁ",
    "gallery.subtitle": "ଚୟନିତ କ୍ଷଣ",
    "gallery.title": "ଓଡ଼ିଶା ପ୍ରକୃତି କ୍ୟାମ୍ପ – ସମ୍ପ୍ରତି ଗ୍ୟାଲେରି",
    "tourOperators.subtitle": "ଆମ ଟୁର ଅପରେଟର୍ମାନଙ୍କୁ ଜାଣନ୍ତୁ",
    "tourOperators.title": "ଟୁର ଅପରେଟର୍ମାନେ",
    "whatsNew.subtitle": "ଇକୋଟୁର ଓଡ଼ିଶା",
    "whatsNew.title": "ଇକୋଟୁରରୁ ସମ୍ବାଦ ଏବଂ ଲେଖା",
    "whatsNew.cta": "ଅଧିକ ସମ୍ବାଦ",
    "whatsNew.readMore": "ଅଧିକ ପଢ଼ନ୍ତୁ",
    "footer.quickLinks": "ଦ୍ରୁତ ଲିଙ୍କଗୁଡ଼ିକ",
    "footer.agents": "ଏଜେଣ୍ଟମାନେ",
    "footer.address": "ଠିକଣା",
    "footer.contact.phone": "ଫୋନ୍",
    "footer.contact.email": "ଇମେଲ୍",
    "footer.about":
      "ଓଡ଼ିଶା ଫରେଷ୍ଟ ଡିଭେଲପମେଣ୍ଟ କର୍ପୋରେସନ୍, ଓଡ଼ିଶା ସରକାରର ଉଦ୍ୟମ",
    "footer.refund": "ଫେରତ ଏବଂ ବାତିଲ୍",
    "footer.privacy": "ଗୋପନୀୟତା ନୀତି",
    "footer.terms": "ସର୍ତ୍ତାବଳୀ",
    "footer.feedback": "ପର୍ଯ୍ୟଟକ ମତାମତ",
    "footer.forms": "ଫର୍ମ",
    "footer.department": "ପର୍ଯ୍ୟଟନ ବିଭାଗ, ଓଡ଼ିଶା ସରକାର",
    "footer.brand": "ଇକୋ ଟୁର ଓଡ଼ିଶା",
    "footer.copyright":
      "କପିରାଇଟ © 2025 ଇକୋ ଟୁର ଓଡ଼ିଶା। ସମସ୍ତ ଅଧିକାର ସଞ୍ଚିତ।",
    "footer.copyrightPrefix": "କପିରାଇଟ 2025",
    "footer.copyrightSuffix": "ସମସ୍ତ ଅଧିକାର ସଞ୍ଚିତ।",
    "booking.tabs.accommodation": "ଆବାସ",
    "booking.tabs.jungleSafari": "ଜଙ୍ଗଲ ସଫାରି",
    "booking.tabs.cruise": "କ୍ରୁଜ୍",
    "booking.tabs.entryTicket": "ପ୍ରବେଶ ଟିକେଟ",
    "booking.tabs.activities": "କାର୍ଯ୍ୟକଳାପ",
    "sidebar.fallback.jungleSafari": "ଜଙ୍ଗଲ ସଫାରି ବୁକିଂ",
    "sidebar.fallback.nightStay": "ରାତିରେ ରହିବା ବୁକିଂ",
    "sidebar.meta.bookedOn": "ବୁକ୍ କରାଯାଇଛି",
    "sidebar.meta.bookingId": "ବୁକିଂ",
    "sidebar.fallback.supportQuery": "ସହାୟତା ପ୍ରଶ୍ନ",
    "sidebar.tab.bookings": "ବୁକିଂଗୁଡ଼ିକ",
    "sidebar.tab.queries": "ପ୍ରଶ୍ନଗୁଡ଼ିକ",
    "sidebar.empty.bookings": "ଆପଣଙ୍କ ନିଶ୍ଚିତ ବୁକିଂ ଏବଂ ସମ୍ପ୍ରତି ଚେଷ୍ଟାଗୁଡ଼ିକ ଏଠାରେ ଦେଖାଯିବ।",
    "sidebar.empty.queries": "ଆପଣ ସୃଷ୍ଟି କରିଥିବା ସହାୟତା ଟିକେଟ୍ ଗୁଡ଼ିକ ଶୀଘ୍ର ଅନୁସରଣ ପାଇଁ ଏଠାରେ ରହିବ।",
    "sidebar.viewAllBookings": "ସମସ୍ତ ବୁକିଂଗୁଡ଼ିକୁ ଦେଖନ୍ତୁ",
    "sidebar.viewAllQueries": "ସମସ୍ତ ପ୍ରଶ୍ନ ଦେଖନ୍ତୁ",
    "sidebar.guestHint": "ପରବର୍ତ୍ତୀ ବୁକିଂ ସମୟରେ ସାଇନ୍ ଇନ୍ କରନ୍ତୁ ଯେପରିକି ଆପଣଙ୍କ ପ୍ରୋଫାଇଲ୍ ଏଠାରେ ଦେଖାଯାଉ।",
    "sidebar.navigation": "ନିୟମନ",
    "sidebar.reachUs": "ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ",
    "sidebar.signOut": "ସାଇନ୍ ଆଉଟ୍",
  },
};
